export default function NotFound() {
	return (
		<div
			style={{
				height: "100%",
				display: "flex",
				alignItems: "center",
				flexDirection: "column",
			}}
		>
			<h1 style={{ fontSize: "4rem", fontWeight: "700", color: "#222" }}>
				Page not found
			</h1>
			<p style={{ fontSize: "1rem", fontWeight: "600", color: "#444" }}>
				Check the URL and try again
			</p>
		</div>
	)
}
